export const commonPopup = {
  title: '',
  content: '',
  ok: 'もちろん',
  cancel: 'キャンセル',
};
